module.exports = __webpack_public_path__ + "staticesp/media/more-white.10b8350f.svg";